export type ChatAuth = {
  embedToken?: string;
  authToken?: string;
};

// Resolved per request by HttpChatTransport (`headers` is Resolvable), so a
// rotated token reaches the wire without rebuilding the transport — useChat
// captures the Chat instance at mount and would ignore a new one.
export function authHeaders(auth: ChatAuth): Record<string, string> {
  return {
    ...(auth.embedToken ? { "x-embed-token": auth.embedToken } : {}),
    ...(auth.authToken ? { Authorization: `Bearer ${auth.authToken}` } : {}),
  };
}
